import Process from './process';
import LoadMore from './load-more';
import Cell from './cell';
import GroupCell from './group-cell';
import Empty from './empty';
import Header from './header';
import Body from './body';
import Pdf from './pdf';

const components = [
  Process,
  LoadMore,
  Cell,
  GroupCell,
  Empty,
  Header,
  Body,
  Pdf,
];

const baseComponents = {
  install(Vue) {
    components.forEach((component) => {
      Vue.component(component.name, component);
    });
  },
};

export default baseComponents;
